import { Badge, Button, Chip } from "@dune/ui";
import { ColumnDef } from "@tanstack/react-table";
import { Eye, Loader2 } from "lucide-react";
import { useState } from "react";

type ContributorAgreement = {
	name: string;
	date: string;
	signatory: string;
	status: string;
	document: {
		id: string;
		bucket: string;
		key: string;
		name: string;
		mimeType: string;
	};
	onDocumentClick: (doc: {
		id: string;
		bucket: string;
		key: string;
		name: string;
		mimeType: string;
	}) => Promise<void>;
};

export const contributorAgreementColumns: ColumnDef<ContributorAgreement>[] = [
	{
		accessorKey: "name",
		header: "Nom",
	},
	{
		accessorKey: "date",
		header: "Date de signature",
	},
	{
		accessorKey: "signatory",
		header: "Signataire",
		cell: ({ row }) => {
			return (
				<Badge
					variant="outline"
					className="bg-blue-50 text-blue-700 border-blue-200"
				>
					{row.original.signatory}
				</Badge>
			);
		},
	},
	{
		accessorKey: "status",
		header: "Statut",
		cell: ({ row }) => {
			return <Chip color={"green"} label={row.original.status} />;
		},
	},
	{
		accessorKey: "document",
		header: "Document(s)",
		cell: ({ row }) => {
			const [isLoading, setIsLoading] = useState(false);
			const doc = row.original.document;

			const handleClick = async () => {
				if (isLoading) return;

				setIsLoading(true);
				try {
					await row.original.onDocumentClick(doc);
				} catch (error) {
					console.error("Erreur lors de l'ouverture du document:", error);
				} finally {
					setIsLoading(false);
				}
			};

			return (
				<div className="flex justify-center">
					<Button
						variant="outline"
						size="sm"
						className="h-8 px-3"
						onClick={handleClick}
						disabled={isLoading}
					>
						{isLoading ? (
							<Loader2 size={14} className="animate-spin" />
						) : (
							<Eye size={14} />
						)}
					</Button>
				</div>
			);
		},
	},
];
